import {useDispatch, useSelector} from "react-redux";
import DropdownMenu, {DropdownItem, DropdownItemGroup} from "@atlaskit/dropdown-menu";
import {CustomIconRef} from "../../../components/CustomIcon";
import {BLOG_STATE_ACTIVE, BLOG_STATE_DRAFT, BLOG_STATE_INACTIVE} from "../constants";
import {setManageBlogModals} from "../../../redux/slices/manageBlogSlice";
import {isSuperAdmin} from "../../../helpers/helperFunctions";

export default function BlogActionMenu({blog}) {

  const dispatch = useDispatch();

  const onEditMetaData = () => {
    dispatch(setManageBlogModals({
      modal: true,
      // data: {blog, state: blog.state === BLOG_STATE_DRAFT || blog.state === BLOG_STATE_INACTIVE ? BLOG_STATE_ACTIVE : BLOG_STATE_INACTIVE}
      data: blog
    }));
  };


  return (
    <DropdownMenu
      trigger={({triggerRef, isSelected, testId, ...props}) => (
        <CustomIconRef ref={triggerRef} size="xl"
                       className={`cursor-pointer ${isSelected ? 'bg-secondary-400' : ''}`} {...props}
                       icon="more_horiz"/>
      )}
    >
      <DropdownItemGroup>
        <_PublishDropdownItem blog={blog}/>

        <DropdownItem onClick={onEditMetaData}>
          Edit Meta Data
        </DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
}

const _PublishDropdownItem = ({blog}) => {

  const dispatch = useDispatch();

  const _user = useSelector((state) => state.authToken.user);

  const onPublish = () => {

    dispatch(setManageBlogModals({
      modal: true,
      isConfirmBlog: true,
      data: {
        blog,
        state: blog.state === BLOG_STATE_DRAFT || blog.state === BLOG_STATE_INACTIVE ? BLOG_STATE_ACTIVE : BLOG_STATE_INACTIVE
      }
    }));

  };


  return (
    <>
      {
        (blog.state === BLOG_STATE_DRAFT || isSuperAdmin(_user)) &&
        <DropdownItem onClick={onPublish}>
          {blog.state === BLOG_STATE_DRAFT || blog.state === BLOG_STATE_INACTIVE ? "Publish" : "Un-publish"}
        </DropdownItem>
      }
    </>
  );
};




